import Vue from 'vue';
import Vuex, { StoreOptions } from 'vuex';
import Axios, { AxiosInstance } from 'axios';
import createPersistedState from 'vuex-persistedstate';
import * as modules from './modules';
import { BASE_URL } from '@/const';
import { Maybe } from '@/models';

Vue.use(Vuex);

export interface IRootState {
  isMobile?: boolean;
  tableFilters?: {
    params?: object;
  };
  error: Maybe<IError>;
}
// tslint:disable-next-line: interface-over-type-literal
export type IError = {
  title: string;
  description?: string;
};

export let client: AxiosInstance = Axios;

let errorInterceptor: number;
// @ts-ignore
const plugins = [];
// if (process.env.NODE_ENV !== 'development') {
plugins.push(
  createPersistedState({
    paths: ['tableFilters'],
  }),
);
// }

export const createUIError = (error: any) => ({
  title: `${error.status && `${error.status}: `}${error?.statusText}`,
  description: JSON.stringify(error?.data || '', null, '\t'),
});

const storeOptions: StoreOptions<IRootState> = {
  strict: true,
  state: {
    error: null,
  },
  mutations: {
    setError(state: IRootState, error: IError) {
      state.error = error;
    },
  },
  modules,
  actions: {
    init({ commit, dispatch, state }) {
      if (errorInterceptor) {
        client.interceptors.response.eject(errorInterceptor);
      }
      client = Axios.create({
        baseURL: `${BASE_URL}auth/`,
        headers: { Authorization: `Bearer ${(state as any).user.token}` },
      });
      errorInterceptor = client.interceptors.response.use(
        (config) => config,
        (error) => {
          if (error?.response?.status === 401) {
            commit('user/setToken', null);
          }
          commit('setError', createUIError(error));
          return Promise.reject(error.response);
        },
      );
      dispatch('user/getUser');
    },
  },
  // @ts-ignore
  plugins,
};

const store = new Vuex.Store(storeOptions);

export default store;
